import Actions from './Icons/Actions'
import AddSubtract from './Icons/AddSubtract'
import Alert from './Icons/Alert'
import ArrowDown from './Icons/ArrowDown'
import ArrowLeft from './Icons/ArrowLeft'
import ArrowRight from './Icons/ArrowRight'
import Automated from './Icons/Automated'
import Bars from './Icons/Bars'
import Bars2 from './Icons/Bars2'
import Building from './Icons/Building'
import Calendar from './Icons/Calendar'
import Chat from './Icons/Chat'
import Check from './Icons/Check'
import CheckMarkCircle from './Icons/CheckMarkCircle'
import Clock from './Icons/Clock'
import CloudUpload from './Icons/CloudUpload'
import Cobra from './Icons/Cobra'
import Cog from './Icons/Cog'
import Concealed from './Icons/Concealed'
import CreditCard from './Icons/CreditCard'
import CurveArrowRight from './Icons/CurveArrowRight'
import Doctor from './Icons/Doctor'
import Document from './Icons/Document'
import Documents from './Icons/Documents'
import DocumentSign from './Icons/DocumentSign'
import Dollar from './Icons/Dollar'
import Download from './Icons/Download'
import Graph from './Icons/Graph'
import Group from './Icons/Group'
import Heart from './Icons/Heart'
import HeartOutline from './Icons/HeartOutline'
import Home from './Icons/Home'
import Info from './Icons/Info'
import LineChart from './Icons/LineChart'
import List from './Icons/List'
import Lock from './Icons/Lock'
import MagnifyingGlass from './Icons/MagnifyingGlass'
import MapPin from './Icons/MapPin'
import MedicalInfo from './Icons/MedicalInfo'
import Message from './Icons/Message'
import NewWindow from './Icons/NewWindow'
import NoteAdd from './Icons/NoteAdd'
import Paperclip from './Icons/Paperclip'
import Pdf from './Icons/Pdf'
import Pencil from './Icons/Pencil'
import Phone from './Icons/Phone'
import PhoneCircle from './Icons/PhoneCircle'
import Plus from './Icons/Plus'
import Printer from './Icons/Printer'
import Profile from './Icons/Profile'
import Ribbon from './Icons/Ribbon'
import Shield from './Icons/Shield'
import ShieldCross from './Icons/ShieldCross'
import Signout from './Icons/Signout'
import Sliders from './Icons/Sliders'
import Split from './Icons/Split'
import Star from './Icons/Star'
import StarCircle from './Icons/StarCircle'
import Summary from './Icons/Summary'
import TestUser from './Icons/TestUser'
import User from './Icons/User'
import UserPlus from './Icons/UserPlus'
import Visible from './Icons/Visible'
import X from './Icons/X'
import XCircle from './Icons/XCircle'
import XShield from './Icons/XShield'

const iconList = {
  actions: Actions,
  addSubtract: AddSubtract,
  alert: Alert,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  automated: Automated,
  bars2: Bars2,
  bars: Bars,
  building: Building,
  calendar: Calendar,
  chat: Chat,
  check: Check,
  checkMarkCircle: CheckMarkCircle,
  clock: Clock,
  cloudUpload: CloudUpload,
  cobra: Cobra,
  cog: Cog,
  concealed: Concealed,
  creditCard: CreditCard,
  curveArrowRight: CurveArrowRight,
  doctor: Doctor,
  document: Document,
  documents: Documents,
  documentSign: DocumentSign,
  dollar: Dollar,
  download: Download,
  graph: Graph,
  group: Group,
  heart: Heart,
  heartOutline: HeartOutline,
  home: Home,
  info: Info,
  lineChart: LineChart,
  list: List,
  lock: Lock,
  magnifyingGlass: MagnifyingGlass,
  mapPin: MapPin,
  medicalInfo: MedicalInfo,
  message: Message,
  newWindow: NewWindow,
  noteAdd: NoteAdd,
  paperclip: Paperclip,
  pdf: Pdf,
  pencil: Pencil,
  phone: Phone,
  phoneCircle: PhoneCircle,
  plus: Plus,
  printer: Printer,
  profile: Profile,
  ribbon: Ribbon,
  shield: Shield,
  shieldCross: ShieldCross,
  signout: Signout,
  sliders: Sliders,
  split: Split,
  star: Star,
  starCircle: StarCircle,
  summary: Summary,
  testUser: TestUser,
  user: User,
  userPlus: UserPlus,
  visible: Visible,
  x: X,
  xCircle: XCircle,
  xShield: XShield,
}

iconList.menu = Bars
iconList.menuClosed = Bars2

export default iconList
